<template>
  <transition
    enter-active-class="transition duration-200 ease-out motion-reduce:transition-none"
    enter-from-class="opacity-0 translate-y-2"
    enter-to-class="opacity-100 translate-y-0"
    leave-active-class="transition duration-150 ease-in motion-reduce:transition-none"
    leave-from-class="opacity-100 translate-y-0"
    leave-to-class="opacity-0 translate-y-2"
  >
    <div v-if="classroomStore.readyLink" role="dialog" aria-modal="false" aria-labelledby="classroom-ready-title"
         class="fixed inset-x-4 bottom-4 z-50 sm:left-auto sm:right-6 sm:bottom-6 sm:w-96 rounded-lg bg-white shadow-lg ring-1 ring-gray-900/10 p-4"
         @keydown.esc="classroomStore.dismiss()">
      <p id="classroom-ready-title" class="text-sm font-medium text-gray-900">{{ $t('general.classroom_ready_title') }}</p>
      <p class="mt-1 text-sm text-gray-600">{{ $t('general.classroom_ready_text') }}</p>
      <div class="mt-4 flex justify-end gap-3">
        <button type="button" @click="classroomStore.dismiss()"
                class="px-3 py-2 text-sm font-medium text-gray-700 rounded-md hover:bg-gray-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-bpblue">
          {{ $t('general.cancel') }}
        </button>
        <a ref="openLink" :href="classroomStore.readyLink" target="_blank" rel="noopener" @click="classroomStore.dismiss()"
           class="inline-flex items-center px-4 py-2 rounded-md bg-bpblue text-sm font-medium text-white shadow-sm hover:bg-blue-500 active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-bpblue">
          {{ $t('general.classroom_open') }}
        </a>
      </div>
    </div>
  </transition>
</template>

<script>
import { useClassroomStore } from "@/stores/classroom";

/*
 * Aviso que aparece solo si el navegador bloqueó la pestaña del aula: el clic en
 * «Abrir aula» es un gesto del usuario y el navegador ya no la bloquea.
 */
export default {
  name: "ClassroomReadyDialog",
  setup() {
    return { classroomStore: useClassroomStore() };
  },
  watch: {
    'classroomStore.readyLink'(link) {
      if (link) {
        this.$nextTick(() => this.$refs.openLink?.focus());
      }
    },
  },
}
</script>
